import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSelect from "./CustomSelect";
import {
  INIT_STATE_SELECTS,
  INDEX,
} from "../../../constants/driveglobalfilterinitalstates";
import moment from "moment";
import $ from "jquery";
import "./Filterpage.css";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../hook/use-http";
import { BsFillSkipForwardBtnFill } from "react-icons/bs";

function Filter(props) {
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const [changedColumn, setChangedColumn] = useState("");
  const [columnfilters, setcolumnfilters] = useState([]);
  const [singleBtn, setsingleBtn] = useState(false);
  const inputElement = useRef();
  const socref = useRef();
  const dischargeref = useRef();
  const odoref = useRef();
  const deltaref = useRef();
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const updateFilter = (arr, index) => {
    let state_ind = INDEX[index];
    setFilterData((prestate) => {
      return { ...filterdata, [state_ind]: arr };
    });
    setChangedColumn(index);
    if (columnfilters.indexOf(index) === -1) {
      setcolumnfilters([...columnfilters, index]);
    }
  };

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    if (enterter_vin != "") {
      let new_vin = enterter_vin.split(",");
      if (new_vin.length == 1) {
        setsingleBtn(true);
      } else {
        setsingleBtn(false);
      }
      setChangedColumn("VIN_NUM");
      let VIN_NUM = "VIN_NUM";
      setFilterData((prestate) => {
        return { ...filterdata, VIN_NUM: new_vin };
      });
      if (columnfilters.indexOf("VIN_NUM") == -1) {
        setcolumnfilters([...columnfilters, "VIN_NUM"]);
      }
    }
  };

  const startDateChanged = (date) => {
    let sDate = "startDate";
    setChangedColumn("startDate");
    setFilterData((prestate) => {
      return { ...filterdata, [sDate]: date };
    });
    if (columnfilters.indexOf("START_DATE") == -1) {
      setcolumnfilters([...columnfilters, "START_DATE"]);
    }
  };

  const endDateChanged = (date) => {
    let eDate = "endDate";
    setChangedColumn("endDate");
    setFilterData((prestate) => {
      return { ...filterdata, [eDate]: date };
    });
    if (columnfilters.indexOf("END_DATE") == -1) {
      setcolumnfilters([...columnfilters, "END_DATE"]);
    }
  };

  const changeSoc = (e) => {
    setChangedColumn("SOC_INDEX");
    setFilterData((prestate) => {
      return { ...filterdata, SOC: parseInt(e.target.value) };
    });
    if (columnfilters.indexOf("SOC_INDEX") == -1) {
      setcolumnfilters([...columnfilters, "SOC_INDEX"]);
    }
  };

  const changeOdo = (e) => {
    setChangedColumn("ODOMETER_INDEX");
    setFilterData((prestate) => {
      return { ...filterdata, ODOMETER: parseInt(e.target.value) };
    });
    if (columnfilters.indexOf("ODOMETER_INDEX") === -1) {
      setcolumnfilters([...columnfilters, "ODOMETER_INDEX"]);
    }
  };

  const changeDischarge = (e) => {
    setChangedColumn("DISCHARGE_INDEX");
    setFilterData((prestate) => {
      return { ...filterdata, DISCHARGE: parseInt(e.target.value) };
    });
    if (columnfilters.indexOf("DISCHARGE_INDEX") === -1) {
      setcolumnfilters([...columnfilters, "DISCHARGE_INDEX"]);
    }
  };
  const changeDelta = (e) => {
    setChangedColumn("DELTA_INDEX");
    setFilterData((prestate) => {
      return { ...filterdata, DELTA: parseInt(e.target.value) };
    });
    if (columnfilters.indexOf("DELTA_INDEX") === -1) {
      setcolumnfilters([...columnfilters, "DELTA_INDEX"]);
    }
  };

  const onsubmit = (e) => {
    e.preventDefault();
    props.onsubmit(filterdata);
    if (filterdata.VIN_NUM.length > 0) {
      fetchData({ url: API_URL_MAIN + "real_time_fault_code/refresh_date", body: { filterdata: filterdata }, }, appyData);
    }
  };

  const [LastRefreshDateRealTimeFaultCOde, setLastRefreshDateRealTimeFaultCOde] = useState("")
  const appyData = (data) => {
    setLastRefreshDateRealTimeFaultCOde(data?.max_date?.value_as_string);
  };

  useEffect(() => {
    const timeInterval = setInterval(() => {
      // if (filterdata.VIN_NUM.length > 0) {
      props.onsubmit(filterdata); // Trigger the function
      fetchData({ url: API_URL_MAIN + "real_time_fault_code/refresh_date", body: { filterdata: filterdata }, }, appyData);
      // }
    }, 300000);

    fetchData({ url: API_URL_MAIN + "real_time_fault_code/refresh_date", body: { filterdata: filterdata }, }, appyData);
    return () => clearInterval(timeInterval); // Clean up interval on unmount
  }, [filterdata, props]);

  const onreset = (e) => {
    setsingleBtn(false);
    e.preventDefault();
    setFilterData(INIT_STATE_SELECTS);
    setcolumnfilters([]);
    setChangedColumn("");
    inputElement.current.value = "";
    socref.current.value = 0;
    dischargeref.current.value = 0;
    odoref.current.value = 0;
    deltaref.current.value = 0;
    props.onreset(INIT_STATE_SELECTS);
  };

  const secondPageCilcked = (e) => {
    e.preventDefault();
    props.onsubmit({ ...filterdata, pageSelected: 2 });
  };
  // $("#filterSearch").css("display", "block");

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className="container-fluid mainDiv">
        <div
          className="bg-light filter FilterDivDIC p-3 mb-3"
          id="filterSearch"
        // style={{ display: "none", zIndex: 1 }}
        >
          <form className="row g-3 mt-2 filterForm">
            <div className="row">
              <div className="col-lg-2 col-md-6 col-sm-12 d-none">
                <div className="mb-0">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="select_col_title"
                  >
                    Start Date
                  </label>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    minDate={moment(
                      new Date("2022-07-01T00:00:00.000Z")
                    ).toDate()}
                    maxDate={moment().subtract(1, "days").toDate()}
                    selected={filterdata.startDate}
                    onChange={startDateChanged}
                  />
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12 d-none">
                <div className="mb-0">
                  <label
                    htmlFor="exampleFormControlInput2"
                    className="select_col_title"
                  >
                    End Date
                  </label>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    minDate={moment(
                      new Date("2022-07-01T00:00:00.000Z")
                    ).toDate()}
                    maxDate={moment().subtract(1, "days").toDate()}
                    selected={filterdata.endDate}
                    onChange={endDateChanged}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="mb-0">
                  <label
                    htmlFor="exampleFormControlInput2"
                    className="select_col_title"
                  >
                    Vin No / Chassis No
                    &nbsp;&nbsp;<span style={{ color: 'black', fontSize: '80%', fontStyle: 'italic' }}>Last Refresh :&nbsp;<span style={{ color: 'black', fontSize: '80%' }}>{LastRefreshDateRealTimeFaultCOde}</span></span>
                  </label>

                  <input
                    autoComplete="off"
                    defaultValue={filterdata.VIN_NUM.join(",")}
                    className="top-filter filter-col"
                    placeholder="Vin No / Chassis No"
                    id="vin_num"
                    ref={inputElement}
                    onChange={vinnumChanged}
                  />
                </div>
              </div>

              <div className="col-lg-2 col-md-4 col-sm-12">
                <div className="mt-3 pt-1">
                  <label htmlFor className="form-label" />
                  <button
                    className="form-control btn btn-primary"
                    onClick={onsubmit}
                  >
                    Search
                  </button>
                </div>
              </div>

              <div className="col-lg-2 col-md-4 col-sm-12">
                <div className="mt-3 pt-1">
                  <label htmlFor className="form-label" />
                  <button
                    className="form-control btn btn-secondary"
                    onClick={onreset}
                  >
                    Reset
                  </button>
                </div>
              </div>

              {singleBtn && (
                <div className="col-lg-2 col-md-4 col-sm-12">
                  <div className="mt-3 pt-1">
                    <label htmlFor className="form-label" />
                    <button
                      className="form-control btn btn-primary"
                      onClick={secondPageCilcked}
                    >
                      <BsFillSkipForwardBtnFill />
                    </button>
                  </div>
                </div>
              )}

              <div className="col-lg-2 col-md-6 col-sm-12 d-none">
                <div className="mb-0">
                  <CustomSelect
                    columnfilters={columnfilters}
                    changedColumn={changedColumn}
                    filterdata={filterdata}
                    lable="CITY"
                    IND="CITY_INDEX"
                    updateFilter={updateFilter}
                  ></CustomSelect>
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-sm-12 d-none">
                <div className="mb-0">
                  <CustomSelect
                    columnfilters={columnfilters}
                    changedColumn={changedColumn}
                    filterdata={filterdata}
                    lable="LOB"
                    IND="LOB_INDEX"
                    updateFilter={updateFilter}
                  ></CustomSelect>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col d-none">
                <div className="mb-0">
                  <CustomSelect
                    columnfilters={columnfilters}
                    changedColumn={changedColumn}
                    filterdata={filterdata}
                    lable="PPL"
                    IND="PPL_INDEX"
                    updateFilter={updateFilter}
                  ></CustomSelect>
                </div>
              </div>
              <div className="col d-none">
                <div className="mb-0">
                  <CustomSelect
                    columnfilters={columnfilters}
                    changedColumn={changedColumn}
                    filterdata={filterdata}
                    lable="PL"
                    IND="PL_INDEX"
                    updateFilter={updateFilter}
                  ></CustomSelect>
                </div>
              </div>

              <div className="col d-none">
                <div className="mb-0" style={{ marginTop: 0 }}>
                  <label
                    htmlFor="exampleFormControlInput2"
                    className="select_col_title"
                  >
                    Dis. SOC % Diff.
                  </label>
                  <select
                    className="form-select react-select__option1 drive_selection_box"
                    aria-label="Default select example"
                    onChange={changeSoc}
                    ref={socref}
                    id="discharge_load_first"
                    name="discharge_load_first"
                  >
                    <option value={0}>All</option>
                    <option value={20}>&gt;20%</option>
                    <option value={40}>&gt;40%</option>
                    <option value={60}>&gt;60%</option>
                    <option value={80}>&gt;80%</option>
                  </select>
                </div>
              </div>

              {loggedInUser.flagForHideShow === "ERC" && (
                <>
                  <div className="col d-none">
                    <div className="mb-0" style={{ marginTop: 0 }}>
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="select_col_title"
                      >
                        Max Odo.
                      </label>
                      <select
                        className="form-select react-select__option1 drive_selection_box"
                        aria-label="Default select example"
                        onChange={changeOdo}
                        ref={odoref}
                        id="discharge_load_first"
                        name="discharge_load_first"
                      >
                        <option value={0}>All</option>
                        <option value={9999}>&lt;10K</option>
                        <option value={10000}>&gt;=10K</option>
                        <option value={20000}>&gt;=20K</option>
                        <option value={30000}>&gt;=30K</option>
                        <option value={40000}>&gt;=40K</option>
                        <option value={50000}>&gt;=50K</option>
                      </select>
                    </div>
                  </div>

                  <div className="col d-none">
                    <div className="mb-0" style={{ marginTop: 0 }}>
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="select_col_title"
                      >
                        Dis. Cycles
                      </label>
                      <select
                        className="form-select react-select__option1 drive_selection_box"
                        aria-label="Default select example"
                        onChange={changeDischarge}
                        ref={dischargeref}
                        id="discharge_load_first"
                        name="discharge_load_first"
                      >
                        <option value={0}>All</option>
                        <option value={1}>&gt;1</option>
                        <option value={5}>&gt;5</option>
                        <option value={10}>&gt;10</option>
                      </select>
                    </div>
                  </div>

                  <div className="col d-none">
                    <div className="mb-0" style={{ marginTop: 0 }}>
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="select_col_title"
                      >
                        Delta Odo.
                      </label>
                      <select
                        className="form-select react-select__option1 drive_selection_box"
                        aria-label="Default select example"
                        onChange={changeDelta}
                        ref={deltaref}
                        id="discharge_load_first"
                        name="discharge_load_first"
                      >
                        <option value={0}>All</option>
                        <option value={500}>&gt;500</option>
                        <option value={1000}>&gt;1000</option>
                        <option value={2000}>&gt;2000</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
            </div>
          </form>
        </div >
      </div >
    </>
  );
}

export default Filter;
